














































/* General */
import Vue from 'vue'

/* Helpers */
import ColorAssistant from '@/helpers/color-assistant'

/* Data objects */
import { IValidationResult } from '@/types/data-objects/global'
import {
  IChecklist,
  IGenericJSONMessage,
  IItemReference,
} from '@/api/types/response.types'

/* API */
import TasksAPI from '@/api/modules/tasks.api'
import ConvosAPI from '@/api/modules/convos.api'

export default Vue.extend({
  name: 'AddUpdateChecklistForm',

  props: {
    originatingChecklist: {
      type: Object as () => IChecklist,
      default: null,
    },
    isLinkedToTask: {
      type: Boolean,
      default: true,
    },
    livesInDrawer: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      ColorAssistant,
      isSubmitting: false,
      formData: {
        title: this.originatingChecklist
          ? this.originatingChecklist.title
          : 'My Checklist',
      },
    }
  },

  computed: {
    projectID(): number {
      return Number(this.$route.params.id)
    },
    itemID(): number {
      return Number(this.$route.params.childId)
    },
  },

  methods: {
    async create(): Promise<IChecklist> {
      this.isSubmitting = true
      try {
        if (this.isLinkedToTask) {
          return await TasksAPI.post_ChecklistCreate(
            this.projectID,
            this.itemID,
            this.formData.title,
          )
        } else {
          return await ConvosAPI.post_ChecklistCreate(
            this.projectID,
            this.itemID,
            this.formData.title,
          )
        }
      } catch (error) {
        throw error
      } finally {
        this.isSubmitting = false
      }
    },

    async update(): Promise<IGenericJSONMessage> {
      this.isSubmitting = true
      try {
        if (this.isLinkedToTask) {
          return await TasksAPI.put_ChecklistUpdate(
            this.projectID,
            this.itemID,
            this.originatingChecklist.id,
            this.formData.title,
          )
        } else {
          return await ConvosAPI.put_ChecklistUpdate(
            this.projectID,
            this.itemID,
            this.originatingChecklist.id,
            this.formData.title,
          )
        }
      } catch (error) {
        throw error
      } finally {
        this.isSubmitting = false
      }
    },

    handleDeleteClick() {
      this.$confirm(`${this.originatingChecklist.title}`, {
        center: true,
        confirmButtonText: 'Yes, Delete',
        confirmButtonClass: 'el-button--strawberry',
        cancelButtonText: 'Cancel',
        cancelButtonClass: 'el-button--text',
        type: 'warning',
        title: 'Are you sure you want to delete this checklist?',
      }).then(() => {
        this.isSubmitting = true
        try {
          if (this.isLinkedToTask) {
            return TasksAPI.delete_ChecklistDelete(
              this.projectID,
              this.itemID,
              this.originatingChecklist.id,
            )
          } else {
            return ConvosAPI.delete_ChecklistDelete(
              this.projectID,
              this.itemID,
              this.originatingChecklist.id,
            )
          }
        } catch (error) {
          throw error
        } finally {
          this.isSubmitting = false
          this.$emit('checklist-deleted', this.originatingChecklist)
        }
      })
    },

    async validateAndSubmit() {
      const validationResult: IValidationResult = this.validate()

      if (!validationResult.success) {
        this.$messaging.showError(validationResult.message)
        return
      } else {
        if (!this.originatingChecklist) {
          this.create()
            .then((checklist: IChecklist) => {
              this.$messaging.showSuccess('Checklist created successfully.')
              this.$emit('checklist-created', checklist)
            })
            .catch((error: Error) => {
              this.$messaging.showError(error.message)
            })
        } else {
          // Update existing checklist
          this.update()
            .then(() => {
              this.originatingChecklist.title = this.formData.title
              this.$messaging.showSuccess('Checklist updated successfully.')
              this.$emit('canceled')
            })
            .catch((error: Error) => {
              this.$messaging.showError(error.message)
            })
        }
      }
    },

    validate(): IValidationResult {
      if (this.formData.title.trim().length === 0) {
        return { success: false, message: 'Please enter a title.' }
      }
      return { success: true }
    },
  },
})
